const Skill = ({ skill }) => {
    return (
        <>
            <div className="skillContainer">
                {skill.img}
                <div className="skillName">{skill.name}</div>
            </div>
        </>
    );
};

export default Skill;
